import { useEffect, useRef } from "react";

const ScrollProgress = () => {
  const ref = useRef(null);
  useEffect(()=>{const h=()=>{const m=document.documentElement.scrollHeight-window.innerHeight;if(ref.current)ref.current.style.transform=`scaleX(${m>0?window.scrollY/m:0})`};window.addEventListener("scroll",h,{passive:true});return()=>window.removeEventListener("scroll",h)},[]);
  return <div className="fixed top-0 left-0 w-full h-[2px] z-[100]"><div ref={ref} className="h-full bg-gradient-to-r from-[#C4A265]/50 via-[#0A4F3B] to-[#C4A265]/50 origin-left" style={{transform:"scaleX(0)"}}/></div>;
};
export default ScrollProgress;